/** How long a captured affiliate token stays valid if nobody signs up yet. */
const TOKEN_TTL_MS = 90 * 24 * 60 * 60 * 1000;

export const AFFILIATE_TOKEN_STORAGE_KEY = 'sk_affiliate_token';

/** Reads a still-valid captured token, if any, without claiming it. */
export function readStoredAffiliateToken(): string | null {
  try {
    const raw = localStorage.getItem(AFFILIATE_TOKEN_STORAGE_KEY);
    if (!raw) return null;
    const { token, capturedAt } = JSON.parse(raw) as { token?: string; capturedAt?: number };
    if (!token || typeof capturedAt !== 'number' || Date.now() - capturedAt > TOKEN_TTL_MS) {
      localStorage.removeItem(AFFILIATE_TOKEN_STORAGE_KEY);
      return null;
    }
    return token;
  } catch {
    return null;
  }
}
